exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-title[data-v-9892b532] {\n  -webkit-mask-image: linear-gradient(0deg, transparent 35px, red 85px);\n}\n@media (min-width: 1024px) {\n.about-title[data-v-9892b532] {\n    -webkit-mask-image: linear-gradient(0deg, transparent 40px, red 120px);\n}\n}", ""]);

// exports
